import { TrendingUp, Users, Target, Zap } from "lucide-react";

export const servicesResultsData = {
  badge: "PROVEN RESULTS",
  headline: "Real Numbers. Real Growth.",
  description:
    "Our clients don't just get marketing they get measurable, predictable revenue growth. Here's what aesthetic clinics achieve when they partner with us.",
  results: [
    {
      icon: <TrendingUp size={32} strokeWidth={1.5} />,
      metric: "3-5x",
      label: "ROI in 90 Days",
      service: "Lead Generation",
      color: "#60a5fa",
    },
    {
      icon: <Users size={32} strokeWidth={1.5} />,
      metric: "+40%",
      label: "Follower Growth",
      service: "Social Media",
      color: "#a78bfa",
    },
    {
      icon: <Target size={32} strokeWidth={1.5} />,
      metric: "25%",
      label: "Booking Recovery",
      service: "Automations",
      color: "#34d399",
    },
    {
      icon: <Zap size={32} strokeWidth={1.5} />,
      metric: "8-12%",
      label: "Conversion Rate",
      service: "Website Design",
      color: "#fbbf24",
    },
  ],
  stats: [
    {
      number: "£140K+",
      label: "Average Patient Revenue Per Clinic/Year",
    },
    {
      number: "+200%",
      label: "Increase in Booking Rates vs Regular Agencies",
    },
    {
      number: "25+",
      label: "Avarge Monthly Booking",
    },
  ],
};
